import { getText, interpolate } from "shared/lib";
import { useI18nReady } from "shared/hooks";

export function TermsOfService() {
  const isI18nReady = useI18nReady();

  // Wait for i18n to be ready before rendering interpolated content
  if (!isI18nReady) {
    return (
      <div className="text-textSubdued text-bodyxs flex flex-col gap-1.5">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="text-textSubdued text-bodyxs flex flex-col gap-1.5">
      <p>
        {interpolate(
          "By using this service, you agree to myLot's {{link}} and that a record of your enquiry will be shared with and retained by Council. ",
          {
            link: (
              <a
                className="text-textLink cursor-pointer underline"
                href="/end-user-agreement"
                rel="noopener noreferrer"
                target="_blank"
                tabIndex={0}
              >
                {getText("End User Agreement")}
              </a>
            ),
          },
        )}

        {interpolate(
          "You can find more information about how myLot (the provider of this service) collects, uses, stores or discloses personal information in their {{link}}.",
          {
            link: (
              <a
                className="text-textLink cursor-pointer underline"
                href="/privacy-policy"
                rel="noopener noreferrer"
                target="_blank"
                tabIndex={0}
              >
                {getText("Privacy Policy")}
              </a>
            ),
          },
        )}
      </p>
    </div>
  );
}
